// extracted by mini-css-extract-plugin
export var divider = "_tc-0";
export var systemMessage = "_tc-1";